<template>
  <div class="article-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="$getThemeImagePath('sup/pc_banner_sup_shop.webp')">
      <div class="content pos-relative">
        <go-to-top />
        <sup-menu />

        <h1 class="main-title">
          ショップについて
        </h1>

        <h2 class="subheading fs_15px">
          勝winのショップでは現金ボーナスを含む各種ボーナスや、<br>
          VIP昇格ボーナス、クーポン、商品などお客様のVIPレベルや、<br>
          お持ちのKatsuポイントに応じて交換することができる選択肢が広がります。
        </h2>

        <hr class="hr_line my_5r">

        <div class="tab-frame">
          <ul class="tab-list">
            <li class="tab-list-item" :class="{'is-btn-active': isActive}" @click="toggleActive">
              PC版
            </li>
            <li class="tab-list-item" :class="{'is-btn-active': !isActive}" @click="toggleActive">
              モバイル版
            </li>
          </ul>

          <div class="tab-contents-wrap">
            <!-- PC版 -->
            <div class="tab-contents" :class="{'is-contents-active': isActive}">
              <h1 class="main-title">
                ステップ 1
              </h1>
              <h2 class="subheading fs_6">
                ホーム画面の「ショップ」をクリック
              </h2>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/shop_pc_tab_01.png')" alt="">
              </div>

              <h1 class="main-title">
                ステップ 2
              </h1>
              <h2 class="subheading fs_6">
                1.「会員特典」：【Katsuポイントウォレット】 商品はポイントギフトパックと交換<br>
                2.「VIPボーナス」： VIPランクアップ特典と交換<br>
                3.「クーポン」： クーポンコードと交換<br>
                4. 現在の【Katsuポイントウォレット】の残高
              </h2>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/shop_pc_tab_02.png')" alt="">
              </div>
            </div>
            <!-- PC版 tab-contents End -->

            <!-- モバイル版 -->
            <div class="tab-contents" :class="{'is-contents-active': !isActive}">
              <h1 class="main-title">
                ステップ 1
              </h1>
              <h2 class="subheading fs_6">
                ホーム画面の「ショップ」をタップ
              </h2>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/shop_mb_tab_01.png')" alt="">
              </div>

              <h1 class="main-title">
                ステップ 2
              </h1>
              <h2 class="subheading fs_6">
                1.「会員特典」：【Katsuポイントウォレット】 商品はポイントギフトパックと交換<br>
                2.「VIPボーナス」： VIPランクアップ特典と交換<br>
                3.「クーポン」： クーポンコードと交換<br>
                4. 現在の【Katsuポイントウォレット】の残高
              </h2>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/shop_mb_tab_02.png')" alt="">
              </div>
            </div>
            <!-- モバイル版 tab-contents End -->
          </div>
        </div>
        <!-- tab-frame End -->
      </div>
      <!-- content End -->
    </div>
    <!-- article-box End -->
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import supMenu from '@/views/page/sup/supMenu'
export default {
  components: {
    goToTop,
    supMenu
  },
  data() {
    return {
      isActive: true
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
    toggleActive() {
      this.isActive = !this.isActive
    }
  }
}
</script>
